module.exports = __webpack_public_path__ + "static/media/ic-nav-holdings-inactive.c9968902.svg";